import React from "react";
import "./fixed-scroll-header.css";

const FixedScrollHeader = ({ handleSave, isSaving = false }) => {
  return (
    <div
      className="ds-save-bar"
      role="group"
      aria-label="Work order actions"
    >
      <button
        type="button"
        className="ds-save-bar__button ds-save-bar__button--primary"
        onClick={(event) => handleSave(event)}
        disabled={isSaving}
      >
        {isSaving ? "Saving..." : "Save"}
      </button>

      <button
        type="button"
        className="ds-save-bar__button ds-save-bar__button--secondary"
        onClick={(event) => handleSave(event, true)}
        disabled={isSaving}
      >
        Save & Stay
      </button>
    </div>
  );
};

export default FixedScrollHeader;
